import { ApolloLink } from '@apollo/client'
import { hermesLogger } from '@core/observability'

export const loggerMiddleware = new ApolloLink((operation, forward) => {
  hermesLogger.info(
    `[GQL Request] - ${operation.operationName} : ${new Date().toISOString()}`,
    {
      request: { operation, forward, context: operation.getContext() },
    }
  )

  return forward(operation).map((response) => {
    hermesLogger.info(
      `[GQL Response] - ${
        operation.operationName
      } : ${new Date().toISOString()}`,
      {
        response,
      }
    )
    return response
  })
})
